import { QuestionType } from "app/types";

export function formatFragrances(fragranceId: any, collection: any[]) {
  if (!fragranceId) {
    return "";
  }
  const fragrancesOptions = collection
    .map(e => ({
      label: e.fragrance?.name,
      value: e.fragrance?.fragranceId,
    }))
    .filter(e => {
      if (Number(fragranceId) === e.value) {
        return e.label;
      }
    });
  let result = "";
  result = fragrancesOptions[0]?.label || "";

  return result;
}
export function formatAnsewerFragrances(fragrances: any, collection: any[]) {
  if (!fragrances) {
    return "";
  }
  const fragrancesOptions = collection
    .map(e => ({
      label: e.fragrance?.name,
      value: e.fragrance?.fragranceId,
    }))
    .filter(e => {
      if (Number(fragrances) === e.value) {
        return e.label;
      }
    });
  let result = "";
  result = fragrancesOptions[0].label;

  return result;
}

export function isValidQuizType(type: string): boolean {
  return ["1", "3", "4", "5", "6"].includes(type);
}

type ModelType = {
  name: string;
  campaignId: any;
  campaign: { name: any };
  language: any;
  maxShots: any;
  type: any;
  userId: any;
  anamneseId: any;
  mandatoryAnamnese: any;
  questions: any;
};

export function getStateByModel(model: ModelType, nameSuffix = "") {
  return {
    quizName: model.name + nameSuffix,
    name: model.name + nameSuffix,
    campaignId: model.campaignId,
    campaignName: model.campaign.name,
    language: model.language,
    maxShots: model.maxShots,
    type: model.type,
    userId: model.userId,
    anamneseId: model.anamneseId,
    mandatoryAnamnese: model.mandatoryAnamnese,
    questions: model.questions,
  };
}

export const saveOriginalQuestions = (
  questions: QuestionType[],
  quizId: number,
) => {
  const questionsJSON = JSON.stringify(questions);
  localStorage.setItem(`originalQuestions_${quizId}`, questionsJSON);
};

export const getOriginalQuestions = (quizId: number): QuestionType[] | null => {
  try {
    const questionsJSON = localStorage.getItem(`originalQuestions_${quizId}`);

    if (!questionsJSON) {
      return null;
    }

    let questions = JSON.parse(questionsJSON);

    if (!Array.isArray(questions)) {
      if (questions.data && Array.isArray(questions.data)) {
        questions = questions.data;
      }
    }

    return questions;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const clearOriginalQuestions = (quizId: number) => {
  localStorage.removeItem(`originalQuestions_${quizId}`);
};

export const getOtherQuizQuestionId = (questions: QuestionType[]) => {
  const usedNumbers = questions.map(question => question.quizQuestionId);
  let temporaryId = -1;

  while (usedNumbers.includes(temporaryId)) {
    temporaryId--;
  }

  return temporaryId;
};
